export const environment = {
  production: false,
  apiUrl: 'https://dev-api.freyr-app.com/api',
  securityApiUrl: 'https://dev-id.freyr-app.com',
  metricsApiUrl: 'https://dev-metrics.freyr-app.com',
  webAppUrl: 'https://dev.freyr-app.com'
};
